import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=warm%20community%20gathering%20at%20sunset%20abstract%20artistic%20style%20soft%20gradient%20warm%20tones%20orange%20and%20cream%20peaceful%20atmosphere%20people%20connecting%20emotional%20warmth%20dreamy%20soft%20focus&width=1800&height=700&seq=cta-bg-2026&orientation=landscape"
        alt="加入海角社区"
        title="加入海角社区情感交流平台"
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/45 to-black/60"></div>

      <div className="relative z-10 max-w-2xl mx-auto px-4 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
          准备好分享你的故事了吗？
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-8 max-w-lg mx-auto leading-relaxed">
          加入海角社区，与百万真实用户一起分享你的情感故事与生活感悟。每一个声音，都值得被听见。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/qinggan-qingsu"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
          >
            立即加入
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white font-medium rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer border border-white/25"
          >
            联系我们
          </Link>
        </div>
      </div>
    </section>
  );
}